<div class="row">
  <div [ngClass]="cull?.type !== 'GeoCull' ? 'col-md-12 col-xl-7' : 'col-12'">
    <sb-card>
      <div card-header classes="no-border">
        <h3>{{ cull?.name }}</h3>
        <small *ngIf="cull && cull.type">{{ typeTranslations[cull.type] }}</small>
      </div>
      <div card-header-more>
        <a ngbTooltip="{{cull?.hidden ? ( 'lang.globals.show' | translate) :( 'lang.globals.hide' | translate) }}"
           *ngIf="hasEditRight()"
           container="body"
           (click)="toggleHideCull()"
           class="btn" [ngClass]="cull?.hidden? 'btn-hover-primary--active' : 'btn-hover-primary'">
          <sb-icon icon="eye"></sb-icon>
        </a>
        <button
          ngbTooltip="{{cull?.lockedBy ? ( 'lang.globals.unlock' | translate) :( 'lang.globals.lock' | translate) }}"
          container="body"
          [disabled]="isLockDisabled()"
          (click)="toggleLockCull()"
          class="mx-2 btn" [ngClass]="cull?.lockedBy? 'btn-success' : 'btn-danger'">
          <sb-icon *ngIf="!cull?.lockedBy" icon="lockClosed"></sb-icon>
          <sb-icon *ngIf="cull?.lockedBy" icon="lockOpen"></sb-icon>
        </button>
        <a *ngIf="hasEditPermission() && !isInModalContext" ngbTooltip="{{ 'lang.globals.edit' | translate }}"
           placement="top" container="body"
           [queryParams]="{returnTo: this.util.getPageLink()}" [sbRouterLink]="util.RoutingID.filterEdit"
           [pathParams]="[{id: 'filterID', value: cull?.id}]">
          <button class="btn btn-hover-primary">
            <sb-icon icon="edit"></sb-icon>
            {{ 'lang.globals.edit' | translate }}
          </button>
        </a>
      </div>
      <div card-fit>
        <div *ngIf="cull?.type !== 'GeoCull'"
             style="height: 608px; width: 100%; padding: 1.25rem 1.8rem 1.25rem 1.8rem; overflow: auto">
          <div *ngIf="cull?.type === 'TimeCull'">
            <sb-filter-time-cull [disabled]="true" [(cull)]="cull" [easyMode]="easyMode"></sb-filter-time-cull>
          </div>
          <div *ngIf="cull?.type === 'PlayerCull'">
            <sb-filter-player-cull [disabled]="true" [(cull)]="cull" [easyMode]="easyMode">
            </sb-filter-player-cull>
          </div>
          <div *ngIf="cull?.type === 'ClientCull'">
            <sb-filter-client-cull [disabled]="true" [(cull)]="cull" [easyMode]="easyMode">
            </sb-filter-client-cull>
          </div>
          <div *ngIf="cull?.type === 'ContentCull'">
            <sb-comp-filter-content-cull [disabled]="true" [(cull)]="cull" [easyMode]="easyMode">
            </sb-comp-filter-content-cull>
          </div>
        </div>
        <div *ngIf="cull?.type === 'GeoCull'">
          <div class="card position-absolute " style="z-index: 9999;right: 10px;top: 10px;">
            <div class="card-body">
              <sb-filter-preview *ngIf="previewComponent" [filter]="previewCull" [isInModalContext]="isInModalContext">
              </sb-filter-preview>
            </div>
          </div>
          <sb-polygon-edit-map
            [mapheight]="560"
            [readOnly]="true"
            [polygons]="displayedPolygons"
            [nominatim]="false" [zoomControl]="true" [initialZoom]="7"
            [roundedCorners]="true">
          </sb-polygon-edit-map>
        </div>
      </div>
    </sb-card>
  </div>
  <div class="col-md-12 col-xl-5" *ngIf="cull?.type !== 'GeoCull'">
    <ng-container *ngIf="showpreview">
      <ng-container *ngIf="cull?.type === 'PlayerCull'">
        <sb-card>
          <div card-fit>
            <div class="card position-absolute tableBg" style="z-index: 9999;right: 10px;top: 10px;">
              <div class="card-body">
                <sb-filter-preview *ngIf="previewComponent" [filter]="previewCull"
                                   [isInModalContext]="isInModalContext">
                </sb-filter-preview>
              </div>
            </div>
            <sb-comp-cluster-map [clusters]="geoAggregation?.data" [mapHeight]="733" [mapZoom]=""
                                 (minMaxPointsChange)="refreshMap($event)"></sb-comp-cluster-map>
          </div>
        </sb-card>
      </ng-container>
      <ng-container *ngIf="cull?.type === 'TimeCull'">
        <sb-card>
          <div card-body>
            <sb-filter-preview *ngIf="previewComponent" [filter]="previewCull">
            </sb-filter-preview>
          </div>
        </sb-card>
      </ng-container>
      <ng-container *ngIf="cull?.type === 'ClientCull'">
        <sb-card>
          <div card-body>
            <sb-filter-preview *ngIf="previewComponent" [filter]="previewCull">
            </sb-filter-preview>
          </div>
        </sb-card>
      </ng-container>
      <ng-container *ngIf="cull?.type === 'ContentCull'">
        <sb-card>
          <div card-body>
            <sb-filter-preview *ngIf="previewComponent" [filter]="previewCull">
            </sb-filter-preview>
          </div>
        </sb-card>
      </ng-container>
    </ng-container>
  </div>
  <div class="col-12 col-md-6 col-lg-3">
    <sb-card>
      <div card-header>
        <div>{{ 'lang.deviceFilterList.currentUsageCount' |translate }}:</div>
      </div>
      <div card-body>
        @for (usage of usages; track usage.type) {
          @if (usage.count > 0) {
            <div class="tw-flex tw-gap-2">
              <div>
                {{ usage.count }}
              </div>
              <div>
                {{ ('lang.globals.' + usage.type) | translate }}
              </div>
            </div>
          }
        }
      </div>
    </sb-card>
  </div>
  @if (showChainedCulls) {
    <div class="col-12 col-md-6 col-lg-3">
      <sb-card>
        <div card-header>
          <div>{{ 'lang.globals.ChainedCulls' |translate }}:</div>
        </div>
        <div card-body>
          <div class="tw-overflow-auto tw-h-50 tw-w-full">
            @for (cull of chainedCulls; track cull.id) {
              <div class="tw-flex tw-justify-between tw-items-center tw-mb-1">
                <div class="text-dark-75 tw-font-semibold">
                  @if (permissionService.hasPermission(permissionService.Permission.cull_list)) {
                    <a (click)="navigateToCull(cull.id)"
                    >
                      {{ cull.name }}
                    </a>
                  } @else {
                    <a>
                      {{ cull.name }}
                    </a>
                  }
                </div>
              </div>
              <hr class="border-dashed">
            } @empty {
              <i>{{ 'lang.globals.noCulls' |translate }}</i>
            }
          </div>
        </div>
      </sb-card>
    </div>
  }
</div>

